import axios from 'axios';
import { API_BASES } from '../config/constants';
import { formatApiResponse } from '../utils/response';

const createClient = (baseURL, withBaseFormat = false) => {
  const client = axios.create({
    baseURL,
    timeout: 120000,
    headers: { 'Content-Type': 'application/json', Accept: 'application/json, text/plain, */*' }
  });

  client.interceptors.request.use((config) => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  // Global network error & timeout catcher
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      const isTimeout = error.code === 'ECONNABORTED' || (error.message && error.message.toLowerCase().includes('timeout'));
      const isNetworkError = error.message === 'Network Error';

      if (isTimeout || isNetworkError) {
        window.dispatchEvent(
          new CustomEvent('global-network-error', {
            detail: { message: error.message }
          })
        );
      }
      return Promise.reject(error);
    }
  );

  if (withBaseFormat) {
    client.interceptors.response.use(
      (response) =>
        formatApiResponse({
          status: response.status,
          data: response.data,
          message: response.data?.message ?? response.statusText
        }),
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  return client;
};

export const apiHowen = createClient(API_BASES.HOWEN_API);
export const apiVss = createClient(API_BASES.VSS);

export const fleetApi = createClient(API_BASES.FLEET_API, true);
export const fleetApiGo = createClient(API_BASES.FLEET_API_GO, true);
export const fleetApiPhp = createClient(API_BASES.API_PHP);
export const fleetApiAddress = createClient(API_BASES.ADDRESS);
export const fleetApiVss = createClient(API_BASES.VSS);
